import $ from 'jquery';
import config from '../../../config';

// Save designation
export function save_designation( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'designation/',
			data: {
                method: 'SAVE_DESIGNATION',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_DESIGNATION",
				designation: response
			})
		})

	}
}

// Get designation
export function get_designation(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'designation/',
			data: {
                method: 'GET_DESIGNATION'
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_DESIGNATION",
				designation: response
			})
		})

	}
}

// Delete designation
export function delete_designation( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'designation/',
			data: {
				method: 'DELETE_DESIGNATION',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_DESIGNATION",
				designation: response
			})
		})

	}
}

// Get By ID designation
export function get_designation_by_id( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'designation/',
			data: {
				method: 'GET_BY_ID_DESIGNATION',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_BY_ID_DESIGNATION",
				designation: response
			})
		})

	}
}


// Edit designation
export function edit_designation( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'designation/',
			data: {
				method: 'EDIT_DESIGNATION',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "EDIT_DESIGNATION",
				designation: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/designation/actions/designation.action.js